import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';



import "./OnboardingPage.css";

const OnboardingPage = () => {
  const [currentIndex, updateIndex] = useState(0);
  // const [questions, setQuestions] = useState([]);
  const [primarySymptom, setPrimarySymptom] = useState('');
  const [activeMedication, setActiveMedication] = useState('');
  const [questions, setQuestions] = useState([]);


  const handleNext = () => {
    updateIndex((prevIndex) => (prevIndex < 3 ? prevIndex + 1 : prevIndex));
  };

  const handlePrev = () => {
    updateIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const handleAskQuestions = async () => {
    try {

      // console.log(1);
      const response = await fetch('http://localhost:5002/api/prompt/questions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          primarySymptom,
          activeMedication,
        }),
      });
      // console.log(11);

      console.log(response);
      let mydata = await response.json();
      console.log(mydata);
      if (mydata.questions === undefined) {
        console.log('undefined responses received')
      } else {
        //console.log(JSON.stringify(data));
        mydata = await mydata.questions;
        
      }
      console.log('Received data:', mydata);
      //data = ["When did you first notice the headache?","How long has it been going on?","Is the pain sharp dull throbbing or constant?","Are there specific pain relievers?","सर्द हवा के झोंके, गरमा-"];
      await localStorage.setItem('questions', mydata);
      setQuestions(mydata);
    } catch (error) {
      console.error('Error asking questions:', error);
    }
  };

  useEffect(() => {
   localStorage.removeItem('questions');
  }, []);


  return (
    <>
      <div className="OnboardModal">
        <div className="modalcontainer">
          <h1>Step One: Onboarding</h1>
        </div>
        {/* <br />
        <div className="model-item" style={{ display: currentIndex === 0 ? 'flex' : 'none' }}>
          <h1>1. About Privacy</h1>
          <img src={modal1} alt="graphic" className="graphics" />
          <p>
            We collect no data during your checkup, any video or audio is lost
            after you close this website.
          </p>
        </div>
        <div className="model-item" style={{ display: currentIndex === 1 ? 'flex' : 'none' }}>
          <h1>2. How it works</h1>
          <img src={modal2} alt="graphic" className="graphics2" />
          <p>
            We utilize bleeding-edge machine learning to generate a health
            report based off your video, speech, and emotion.
          </p>
        </div>
        <div className="model-item" style={{ display: currentIndex === 2 ? 'flex' : 'none' }}>
          <h1>3. Get instant help</h1>
          <img src={modal3} alt="graphic" className="graphics3" />
          <p>
            At the end, get a list of recommended local doctors based on your
            conditions. After you leave, we’ll purge all your data!
          </p>
        </div> */}

        <form>
          <div className="model-item" style={{ display: currentIndex === 1 ? 'flex' : 'flex' }}>
            <h1>Give us brief about the illness</h1>
            <br />
            <label className="form-label">
              Primary Symptom:
              <input type="text" value={primarySymptom} onChange={(e) => setPrimarySymptom(e.target.value)} className="form-input" />
            </label>
            <br />
            <label className="form-label">
              Active Medication:
              <input type="text" value={activeMedication} onChange={(e) => setActiveMedication(e.target.value)} className="form-input" />
            </label>
            <br></br>
            {/* <button type="button" onClick={handleAskQuestions} className="form-button">
              Ask Questions
            </button> */}

          </div>
          <div className="button-row">
            {currentIndex !== 0 ? (
              <button className="back" onClick={handlePrev}>
                Go Back
              </button>
            ) : (
              <Link to="/">
                <button className="back">Return Home</button>
              </Link>
            )}
            {currentIndex === 0 ? (
              <Link to="/main">
                <button className="next" onClick={handleAskQuestions}>Finish</button>
              </Link>
            ) : (
              <button className="next" onClick={handleNext}>
                Next
              </button>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default OnboardingPage;
